const baseURL =
  process.env.STAGING === 'staging'
    ? 'https://api-staging.ect.nmma.org'
    : process.env.STAGING === 'development'
      ? 'http://localhost:8765'
      : process.env.NODE_ENV === 'production'
        ? 'https://api.ect.nmma.org'
        : process.env.STAGING === 'local'
        ? 'http://localhost:8765'
          : 'https://api-staging.ect.nmma.org';

const isDev = process.env.NODE_ENV !== 'production' && process.env.STAGING !== 'staging';

export default {
  baseURL,
  store: 'root',
  client_id: 'nmma',

    communityHub:
    process.env.STAGING === 'production'
      ? {
          authorizationEndpoint: 'https://engage.nmma.org/services/oauth2/authorize',
          tokenEndpoint: '/user/oauth/token',
          clientId: '3MVG9FINO1nsxRuAqq2SfGKT6TFAKhnl86KK20fol9ndkhgtRLbAKbFq1yXwa4ztHWEMRT8K3ga2MjVKw5Dh1',
        }
      : {
          authorizationEndpoint: 'https://nmma--staging.sandbox.my.site.com/communityhub/services/oauth2/authorize',
          tokenEndpoint: '/user/oauth/token',
          clientId: '3MVG9Fob0S.D_AiRbYaRTQl8lX9Wf9Fq4DXbXTrXQ2dYLcm3m.JMT0j0ubkDQHRR.Ibk97NcriTjDf5qf.ddg',
          
        },
};



// WEBPACK FOOTER //
// ./src/app/config.js